import { titleLookup } from "../../../../modules/forms/Lookups";

export const sharedSurveyProps = {
  showPrevButton: false,
  showCompletedPage: false,
  showQuestionNumbers: "off",
  showProgressBar: false,
  progressBarType: "pages",
  pagePrevText: "Back",
  pageNextText: "Next",
  completeText: "Next",
  widthMode: "responsive",
  fitToContainer: true,
};

export const yesNoChoices = [
  { value: "yes", text: "Yes" },
  { value: "no", text: "No" },
];

export const pensionFundQuestion = {
  type: "text",
  name: "annuity.pensionFund",
  title: "Your Pension Value",
  isRequired: true,
  prefix: "\u00a3",
  inputType: "tel", // tel opens the native number pad on mobile - type "number" adds unnecessary browser validation and breaks the currency mask

  validators: [
    {
      type: "numeric",
      text: "Please enter a valid amount between \u00a310,000 and \u00a310,000,000",
      minValue: 10000,
      maxValue: 10000000,
    },
  ],
  maskType: "currency",
  maskSettings: {
    prefix: "\u00a3 ",
    max: 2100000000,
  },
  inputTextAlignment: "left",
};

export const personalDetailQuestions = [
  {
    type: "dropdown",
    name: "title",
    title: "Title",
    autocomplete: "honorific-prefix",
    isRequired: true,
    renderAs: "select", // forces the native OS <select> picker instead of SurveyJS's custom popup
    choices: titleLookup.map((option) => ({
      value: option.value,
      text: option.label,
    })),
  },
  {
    type: "text",
    name: "firstName",
    title: "First Name",
    autocomplete: "given-name",
    isRequired: true,
  },
  {
    type: "text",
    name: "lastName",
    title: "Last Name",
    autocomplete: "family-name",
    isRequired: true,
    validators: [
      {
        type: "regex",
        text: "Please enter a valid last name.",
        regex: "^[a-zA-Z\\s'-]{2,40}$",
      },
    ],
  },
  {
    type: "addressautocomplete",
    name: "address",
    title: "Address",
    placeholder: "Start typing your address...",
    isRequired: true,
  },
  { type: "text", name: "postcode", title: "Postcode", visible: false },
  { type: "text", name: "city", title: "City", visible: false },
  { type: "text", name: "region", title: "Region", visible: false },
  { type: "text", name: "country", title: "Country", visible: false },
  {
    type: "text",
    name: "email",
    title: "Email",
    inputType: "email",
    autocomplete: "email",
    isRequired: true,
    validators: [
      {
        type: "regex",
        text: "Please enter a valid email address.",
        regex: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
      },
    ],
  },
  {
    type: "text",
    name: "primaryPhone",
    title: "Telephone",
    inputType: "tel",
    autocomplete: "tel",
    isRequired: true,
    maxLength: 15,
    validators: [
      {
        type: "regex",
        regex: "^[0-9+()\\-\\s]{1,15}$",
        text: "Please enter a valid number.",
      },
    ],
  },
];
